import * as types from '../actions/types';
import dotProp from 'dot-prop-immutable';

const initialState = {
  ticketIds: {},
};

const inProgressTreeAndWizardLocation = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_IN_PROGRESS_TREE_AND_WIZARD_LOCATION:
      return dotProp.set(state, `ticketIds.${action.ticketId}`, action.data);
    case types.CLEAR_IN_PROGRESS_TREE_AND_WIZARD_LOCATION:
      return dotProp.delete(state, `ticketIds.${action.ticketId}`);
    default:
      return state;
  }
};

export default inProgressTreeAndWizardLocation;
